import Launcher from './launcher';

export const AutoLauncher = new Launcher();
